import { Link } from 'react-router-dom';
import {
  NotFoundBox,
  GlitchTitle,
  Subtitle,
  HomeButton,
  GlowCircle,
} from './NotFound.styled';

const NotFound = () => {
  return (
    <NotFoundBox>
      <GlowCircle />
      <GlitchTitle>404</GlitchTitle>
      <Subtitle>Page not found</Subtitle>
      <p>The page you're looking for doesn't exist or has been moved.</p>
      <HomeButton as={Link} to="/">
        Back to Home
      </HomeButton>
    </NotFoundBox>
  );
};

export default NotFound;
